import { render, staticRenderFns } from "./AiChatboxComponent.vue?vue&type=template&id=59dc708c"
import script from "./AiChatboxComponent.vue?vue&type=script&lang=js"
export * from "./AiChatboxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports